import { VmExpiryDatesResponse } from '../../../../models/responses/vm-expiry-dates-response';
import { ExpiryUtilies } from './../../../../Util/expiry-utils';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  NgbModal,
  NgbModalConfig,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from 'src/app/common-layout/popup/popup.component';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { CustomAction } from 'src/app/types/table.type';
import { ServerdetailspopupComponent } from '../serverdetailspopup/serverdetailspopup.component';
import { SingeServerDetails } from 'src/app/models/single-server-details.model';
import { SingeServerCompleteDetails } from 'src/app/models/single-server-complete-details.model';
import { TableUtil } from 'src/app/common-layout/table/table.component';
import { Router } from '@angular/router';
import Helper from 'src/app/Util/helper';
import { environment } from 'src/environments/environment';
import { ProvisionedVirtualMachine } from 'src/app/models/provisioned-virtual-machine.model';
import { debounce, debounceTime, interval, Subject, Subscription, takeUntil } from 'rxjs';
import { VirtualMachineService } from '../services/virtual-machine.service';
import { VmAction } from 'src/app/enums/vm_action.enum';
import { RefreshIdentifier } from 'src/app/enums/refresh-identifier.enum';
import { CloudRefreshService } from 'src/app/services/cloud-refresh.service';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { NonHostedEnvDetail } from 'src/app/models/non-hosted-env-detail.model';
import { StringUtilities } from 'src/app/Util/string-utils';
import {
  faInbox,
  faNetworkWired,
  faRotate,
  faRotateRight,
  faPlus,
  faTrash,
  faRotateLeft,
  faPlay,
  faHome,
  faStop,
  faCircle,
  faSpinner,
  faClose,
  faLink,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { AllowedIPRequest, CompleteServerDetails, RemovePeeringRequest, VirtualMachineDeletionRequest, VMRetryCreateRequest, VmStatus, VnetPeeringResponse } from 'src/app/interfaces/vm.interface';
import { AWSVpcPeeringStatus, AzureVnetPeeringStatus, ConnectionType, MachineStatusMap } from 'src/app/types/vm.type';
import { API_ERRORS } from 'src/app/Util/constants';
import { ConfigureSingleEnvironment, EnvironmentDetail, EnvironmentTabType, ServerDetail } from 'src/app/types/environment.type';
import { CheckBoxSelection, EnvironmentTabEnum, EnvironmentTabs } from 'src/app/enums/environments.enum';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { AWSVpcPeeringStatuses, AzureVnetPeeringStatuses, ConnectionTypeEnum } from 'src/app/enums/vm.enum';
import { VNETPeeringService } from 'src/app/connection/services/vnet-peering.service';
import { Keys, Regex } from 'src/app/Util/keys';
import { HttpErrorResponse } from '@angular/common/http';
import { CloudVendor } from 'src/app/enums/cloud-vendor.enum';
import { CloudNotificationResponse } from 'src/app/models/cloud-notification-response.model';
import StringHelper from 'src/app/Util/string-helper';
import { DateHelper } from 'src/app/Util/date-helper';
import { SubscriptionCreatedEnviornment } from 'src/app/interfaces/environment.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import FormValidators from 'src/app/Util/vaidators';
import { IPValidator } from 'src/app/Util/ip-validator';
import { AddTrustedTenantPath } from 'src/app/types/az-add-trusted-tenant.type';
import { AddTrustedTenantPathEnum } from 'src/app/enums/add-trusted-tenant.enum';
import { ConnectionPersistenceService } from 'src/app/connection/services/connection-persistence.service';
import { GuideComponent } from './guide/guide.component';


@Component({
  selector: 'app-environment-view-single',
  templateUrl: './environment-view-single.component.html',
  styleUrls: ['./environment-view-single.component.sass'],
})
export class EnvironmentViewSingleComponent implements OnInit, OnDestroy {

  ConnectionTypeEnum = ConnectionTypeEnum
  faQuestionCircle = faQuestionCircle
  faHome = faHome;
  faPlus = faPlus;
  faTrash = faTrash;
  faRotate = faRotate;
  faRotateLeft = faRotateLeft;
  faRotateRight = faRotateRight;
  faPlay = faPlay;
  faStop = faStop;
  faNetworkWired = faNetworkWired;
  faInbox = faInbox;
  faCircle = faCircle
  isRemoveClicked = false
  faSpinner = faSpinner
  faClose = faClose
  falink = faLink
  private unsubscribe$ = new Subject<void>()
  private planEdition:string =''
  EnvironmentTabEnum = EnvironmentTabEnum
  activeTab: EnvironmentTabType = EnvironmentTabEnum.SERVERS

  selectivePublicIps: boolean = false;

  @ViewChild('deletePeeringModal') deletePeeringModal: any

  deletePeeringInput: string = ''
  deleteServersInput: string = ''
  isPeeringDeletionDisabled: boolean = true
  vmStatus: any[] = []
  selectedPeeringId: string | undefined = undefined
  selectedVnetConnectionId: number | undefined = undefined
  isDeletingPeering: boolean = false
  private openedWindows: { [key: string]: Window | null } = {};
  isLoadingPeerings: boolean = false
  selectedPeering: VnetPeeringResponse | undefined = undefined
  peerings = new MatTableDataSource<VnetPeeringResponse>([])
  peeringSelection = new SelectionModel<VnetPeeringResponse>(true, []);
  peeringColumns = ['Peering ID', 'Account ID', 'Network Resource ID', 'Client Network Resource ID', 'Client Network CIDR', 'Region', 'Status', 'Action'];

  servers = new MatTableDataSource<ServerDetail>([])
  serverToView: CompleteServerDetails;

  selection = new SelectionModel<ServerDetail>(true, []);

  @ViewChild('viewServerDetailsModal') viewServerDetailsModal: TemplateRef<any>;
  @ViewChild('connectionDetailsModal') connectionDetailsModal: TemplateRef<any>;

  @ViewChild('configureAllowedIPsModal') configureAllowedIPsModal: TemplateRef<any>;
  @ViewChild('clientPeeringDeleteModal') clientPeeringDeleteModal: TemplateRef<any>;

  @ViewChild('deleteServersModal') deleteServersModal : TemplateRef<any>;

  displayedColumns: string[] = [
    'Server Name',
    'IP Address',
    'Created At',
    'Status',
    'Action'
  ];

  subscriptionId: string;
  environmentDetails: EnvironmentDetail;
  environmentName: string;
  formRef: NgbModalRef;
  viewServerDetailsRef: NgbModalRef;
  viewServerConnectionDetailsRef: NgbModalRef;
  environmentInfo: any;
  nonHostedEnvironmentInfo: NonHostedEnvDetail;
  selectedItems = [];
  wizardTabs: string[]
  tabIndex: number;
  disableButtons = true;
  isServersLoading: boolean = false;
  expiryDates: VmExpiryDatesResponse;
  action = VmAction;
  webManagerPort: number | null = null;
  isHosted: boolean = true;
  private getServersSubscription: Subscription;
  private getVmExpiryDatesSubscription: Subscription;
  private getWebManagerPortSubscription: Subscription;
  routeState: any
  environment: ConfigureSingleEnvironment
  selectedServer: VirtualMachineDeletionRequest
  isServerRunning = true
  selectedVmsString: string

  allowedIPsFormGroup: FormGroup;
  invalidIPsErr: string[]  = [];
  isAllowedIPsSubmitted: boolean = false;

  isLoadingAllowedIPs: boolean = true;
  isAddingAllowedIPs: boolean = false;

  allowedIPs: string[] = [];
  duplicateAllowedIPs: string[] = [];
  updatedAllowedIPs: string[] = [];

  azLinkDeletePeering: string | undefined = undefined;
  ncacheConnectCachePublicIPLink: string | undefined = undefined;
  azClientPeeringConnectionName: string | undefined = undefined;
  private nCacheWebManagerLinkTemplate : string | undefined = undefined

  vmClusterFormationStatuses: any[] = [];

  private allVMsClusterFormationComplete: boolean = false;

  ngDoCheck() {
    this.checkArrayAndToggleButtons();
  }

  private checkArrayAndToggleButtons() {
    if (this.ifAnyServerAlreadyInRemovingState(this.selection.selected)) {
      this.disableButtons = true;
      return;
    }
    if (this.selection.selected.length > 0) {
      this.disableButtons = false
    }
    else {
      this.disableButtons = true
    }
  }

  ignoreColumns = ['Resource Id', 'Id'];
  columnNames = [
    'Id',
    'Resource Id',
    'Server Name',
    'Type',
    'Public IP',
    'Private IP',
    'Status',
  ];
  showSorting = false;
  showCheckBoxes = false;
  completeServersInfo: ProvisionedVirtualMachine[] = [];
  fakeServers: any[] = [];
  columnRenderers = new Map()
    .set(6, TableUtil.generateStatusListWIthColorableIcons)
    .set(2, TableUtil.generateText);

  actions: Array<CustomAction<SingeServerDetails>> = [
    {
      displayName: 'View Details',
      callback: this.openServerDetailsPopup.bind(this),
      color: 'link',
    },
  ];

  constructor(
    private readonly formBuilder: FormBuilder,
    private router: Router,
    private environmentService: EnvironmentService,
    private notificationService: CloudNotificationService,
    private subscriptionService: CloudSubscriptionService,
    private envirForm: NgbModal,
    private serverDetailPopup: NgbModal,
    private ServerConnectionDetailsPopup: NgbModal,
    private vmService: VirtualMachineService,
    private refreshService: CloudRefreshService,
    details: NgbModalConfig,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private cloudRefreshService: CloudRefreshService,
    private vnetPeeringSvc: VNETPeeringService,
    private connectionSvc: ConnectionPersistenceService
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    config.centered = true;
    config.windowClass = '';
    details.backdrop = 'static';
    details.keyboard = false;
    details.centered = true;
    details.windowClass = 'serverPopup';
    this.initializeallowedIPsForm();
  }

  ngOnInit(): void {
    this.getExternalLinks();
    this.refreshService.startRefreshService()
    this.getSubscriptionId()
    this.getRouteState()
    this.observeServerStatus()
    this.observeServerClusterFormation();
    this.getPeerings()
    this.onPageLoad();
    this.getAllowedIPsList(this.subscriptionId, this.environment.environmentName);
  }

  private onPageLoad() {
    this.triggerVmrefreshStatus()
  }

  private triggerVmrefreshStatus() {
    if (this.subscriptionId != null) {
      this.environmentService.triggerVmStatusRefresh(this.subscriptionId).subscribe({
        next: (res) => {
        },
        error: (err) => {
        }
      })
    }
  }

  onAllowedIpsRadioChange(btn) {
    this.selectivePublicIps = btn == 'selective';
    if (this.selectivePublicIps == false) this.allowedIPsFormGroup.controls.allowedIPs.setErrors(null);
    else this.allowedIPsFormGroup.controls.allowedIPs.setValue('');
  }

  getResource(){
    if(this.environment?.resourceId == null) return "---";
    if(this.environment?.cloudVendor == CloudVendor.Azure){
      let resourceChunks = this.environment.resourceId.split("/");
      return resourceChunks[resourceChunks.length - 1];
    }
    else{
      return this.environment?.resourceId;
    }
  }

  getAvailabilityZone(){
    return this.environment?.cloudVendor == CloudVendor.Azure ? this.environment.availabilityZone == "0" ? "Default" : "zone - "+ this.environment.availabilityZone : this.environment.availabilityZone
  }

  getIsPublicIPAssgined(){
    return this.environment?.assignPublicIp == true ? "Enabled" : "Disabled";
  }

  getConnectionType(){
    if(this.environment?.assignPublicIp == true){
      return "Public IP";
    }
    return this.isAWS() ? "VPC Peering" : "VNET Peering";
  }

  private getPeerings(): void {

    this.isLoadingPeerings = true

    this.vnetPeeringSvc.getPeerings(this.subscriptionId, this.environment.environmentName).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (peerings) => {
        this.isLoadingPeerings = false
        this.peerings.data = peerings
      },

      error: (err: HttpErrorResponse) => {
        this.isLoadingPeerings = false;
        this.showToastNotification("get-peerings-failed", "An unexpected error occured while fetching Peerings.", CloudNotificationStyle.danger)
      }

    })

  }

  goToGuidePage(){
    window.open("https://www.alachisoft.com/resources/docs/ncache/prog-guide/connect-to-cache.html?tabs=net%2Cnet1%2Cnet2%2Cnet3%2Cnet4%2Cnet5%2Cnet6", "_blank");
  }


  private getRouteState() {
    this.routeState = history.state
    this.environment = this.routeState.environment
    this.displayedColumns = this.getColumnNames();
    this.planEdition = this.routeState?.cloudSubscription?.planTitle
    this.initializeServers(this.environment.servers)
  }

  getReservedServers() {
    let ans = 0
    if (this.environment.servers.length >= this.environment.reservedCapacity) {
      ans = 0
    }
    else {
      ans = Math.abs(this.environment.reservedCapacity - this.environment.servers.length)
    }
    return ans
  }

  private getSubscriptionId() {
    this.subscriptionId = this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId)
    this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId)
    this.registerVmStatus(this.subscriptionId);
  }

  private initializeServers(servers: ServerDetail[]) {
    this.updateVmStatus(servers)
  }

  ifAnyServerAlreadyInRemovingState(selections: ServerDetail[]) {
    return selections.some((server) => server.status == "deleting")
  }

  triggerVMAction(vm) {
    vm.retryButtonDisable = true;
    if (vm.status === 'provisioning_failed') {

      let req: VMRetryCreateRequest = {
        subscriptionId: this.subscriptionId,
        environmentName: this.environment.environmentName,
        vmId: vm.id
      }
      this.vmService.retryCreateVM(req).subscribe({
        next: (res) => {
          this.notificationService.createToastNotification("retry-server-create", `Retrying to provision server ${vm.name}`, CloudNotificationStyle.success)
          this.refresh();
        },
        error: (err) => {
          this.notificationService.createToastNotification("retry-server-create", Helper.resolveErrorMessage(err), CloudNotificationStyle.success);
          vm.retryButtonDisable = false;
        }
      })
    }
  }

  getActionButtonText(status: string): string {
    if (status === 'provisioning_failed') return 'Retry Provisioning';
    else return "---";
  }

  setWizardTabs() {
    this.wizardTabs = [
      EnvironmentTabs.Servers,
      EnvironmentTabs.VPCPeering,
      EnvironmentTabs.PrivateLink
    ];
    this.initializeTabIndex();
  }

  private initializeTabIndex() {
    this.tabIndex = 0
  }

  getVmState() {

  }



  ngAfterViewInit(): void {
    this.subscriptionService
      .checkIfHosted(this.subscriptionId)
      .subscribe((result) => {
        this.isHosted = result;
        if (this.isHosted) {
          this.getServers();
        } else {
          this.columnNames = [
            'Machine Name',
            'Public IP',
            'Private IP',
            'CPU Cores',
            'Memory',
          ];
          this.columnRenderers = new Map();
          this.actions = [];
        }
      });
  }


  onWizardTabChange(tabIndex: number) {
    this.tabIndex = tabIndex;
  }


  getServers(): void {
    this.isServersLoading = true
    this.environmentService.getEnvironmentMachines(this.environment.environmentName, this.subscriptionId).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (servers) => {
        this.isServersLoading = false
        this.environment.servers = servers
        this.initializeServers(servers)

        servers.forEach(e => {
          let found = this.vmClusterFormationStatuses.find(vmStatus => vmStatus.vmId === e.id);
          if ((found == undefined || found == null || found == false) && (e.status != "provisioning_failed")) {
              this.vmClusterFormationStatuses.push({ vmId: e.id, isClusterFormationComplete: false })
          }
        });
      },

      error: () => {
        this.isServersLoading = false;
        this.showToastNotification(API_ERRORS.get_environment_servers.title, API_ERRORS.get_environment_servers.message, CloudNotificationStyle.danger)
      }

    })
  }

  vmStatuses: { vmId: string; state: number }[] = [];
  registerVmStatus(subId: string) {
    const params = {
      subscriptionId: subId,
      process: true,
      lastUpdateTime: new Date().toISOString(),
    };

    this.refreshService
      .register(RefreshIdentifier.vmStatus, params, 0.1)
      .subscribe((res) => {
        if (Array.isArray(res)) {
          res.forEach((newStatus) => {
            const index = this.vmStatuses.findIndex(
              (status) => status.vmId === newStatus.vmId
            );
            if (index > -1) {
              if (this.vmStatuses[index].state !== newStatus.state) {
                this.vmStatuses[index].state = newStatus.state;
              }
            } else {
              this.vmStatuses.push(newStatus);
            }
          });
        }
        this.updateServerStatuses();
      });
  }

  updateServerStatuses() {
    const vmStatusesMap = new Map(
      this.vmStatuses.map((vmStatus) => [vmStatus.vmId, vmStatus])
    );

    this.fakeServers.forEach((server) => {
      const vmStatus = vmStatusesMap.get(server.ResourceId);
      if (vmStatus) {
        const status = StringUtilities.getVmStatusLabel(vmStatus.state);
        server.Status = new Map([
          [server.PrivateIP, { status, resourceId: server.ResourceId }],
        ]);
      }
    });

    this.fakeServers = [...this.fakeServers];
  }

  openDeletePopUp() {
    this.formRef = this.envirForm.open(PopupComponent);
    if (!this.isHosted) {
      Helper.configurePopup(this.formRef, {
        title: 'Unable to Delete Environment',
        message: 'Contact support team to delete environment through',
        btnTitle: 'Okay',
        viewLink: true,
        link: 'https://www.alachisoft.com/company/contact-us.html',
        linkMessage: 'our contact page',
        viewCancelBtn: false,
        valueProcessor: (receivedConfirmation) => {
          if (receivedConfirmation) {
            this.formRef.close();
          }
        },
      });
    } else {
      Helper.configurePopup(this.formRef, {
        title: 'Delete Environment Confirmation',
        message: 'Are you sure you want to delete environment?',
        btnTitle: 'Confirm',
        viewInput: true,
        viewCrossBtn: false,
        placeholder: 'Environment Name',
        pattern: new RegExp('^' + this.environmentInfo.name + '$'),
        valueProcessor: (receivedConfirmation) => {
          if (receivedConfirmation == this.environmentInfo.name) {
          }
          this.formRef.close();
        },
      });
    }
  }

  serversToDelete(){
    return this.selection.selected
  }


  private checkIfAllVmsSelected() {
    if (this.servers.data.length == 1 || this.servers.data.length == this.selection.selected.length) return true
    return false
  }

  openServerDetailsPopup(item: any) {
    const envToView = this.getServerToView(item.ResourceId);
    const serverDetails = this.createServerDetails(envToView);
    this.OpenPopup(serverDetails);
  }

  getServerToView(resourceId: string): ProvisionedVirtualMachine | undefined {
    return this.completeServersInfo.find(
      (server) => server.resourceId === resourceId
    );
  }

  createServerDetails(
    envToView: ProvisionedVirtualMachine
  ): SingeServerCompleteDetails {
    let expiresOnDate: Date | string | null = '';
    expiresOnDate = ExpiryUtilies.calculateExpiryDate(
      this.expiryDates.vmYearlyExpiryDate,
      this.expiryDates.vmMonthlyExpiryDate,
      this.environmentInfo.autoRenewal
    );
    return this.createServerDetailsObject(envToView, expiresOnDate);
  }

  private createServerDetailsObject(
    envToView: ProvisionedVirtualMachine,
    expiresOnDate: Date | string | null
  ): any {
    return {
      instanceName:
        (envToView?.name?.includes('Marked for removal')
          ? envToView?.name?.split('(')[0]
          : envToView?.name) ?? '',
      EnvironmentType: this.environmentInfo?.type ?? '',
      VMSize: this.environmentInfo?.serverProfileDisplayName ?? '',
      SubscriptionID: this.subscriptionId ?? '',
      Region: this.environmentInfo?.regionDisplayName ?? '',
      OperatingSystem: this.environmentInfo?.operatingSystem
        ? `${this.environmentInfo.operatingSystem
          .charAt(0)
          .toUpperCase()}${this.environmentInfo.operatingSystem.slice(1)}`
        : '',
      Vpc: this.environmentInfo.vendor == 'aws',
      CIDR_Block: '10.0.0.0/12',
      PublicIP: envToView?.provisionedNetworkInterface[0]?.publicIp ?? '',
      PrivateIP: envToView?.provisionedNetworkInterface[0] ?? '20.20.20.20',
    };
  }

  OpenPopup(serverDetails: SingeServerCompleteDetails | undefined) {
    if (serverDetails) {
      this.viewServerDetailsRef = this.serverDetailPopup.open(
        ServerdetailspopupComponent
      );
      this.viewServerDetailsRef.componentInstance.environmentDetails =
        serverDetails;
    }
  }

  private updateVmStatusToRemoving(deleteingVms: number[]) {
    deleteingVms.forEach((vmId) => {
      this.servers.data.forEach(e => {
        if (e.id == vmId) {
          e.status = 'deleting';
        }
      })
    })
    this.ifAnyServerAlreadyInRemovingState(this.selection.selected)
  }

  private updateVmStatus(servers: ServerDetail[]) {
    this.servers.data = servers.map((server) => { return { ...server, status: server.status } });
  }

  removeVm(vmId: number) {

    let selectedVm: VirtualMachineDeletionRequest = {
      subscriptionId: this.subscriptionId,
      vmIds: [vmId],
      environmentName: this.environment.environmentName
    }
    this.notificationService.removeToastNotification('delete-server');
    this.vmService
      .deleteVms(selectedVm)
      .subscribe(
        {
          next: (res) => {
            this.showToastNotification(
              'delete-server',
              'Removing server(s)',
              CloudNotificationStyle.success
            );
            this.updateVmStatusToRemoving(selectedVm.vmIds)
          },
          error: (err) => {
            this.showToastNotification(
              'delete-server',
              Helper.resolveErrorMessage(err),
              CloudNotificationStyle.danger
            );
          }
        }
      );
  }

  removeVms() {
    this.notificationService.removeToastNotification('delete-server');
    this.vmService
      .deleteVms(this.selectedServer)
      .subscribe(
        {
          next: (res) => {
            this.showToastNotification(
              'delete-server',
              'Removing server(s)',
              CloudNotificationStyle.success
            );
            this.updateVmStatusToRemoving(this.selectedServer.vmIds)
          },
          error: (err) => {
            this.showToastNotification(
              'delete-server',
              Helper.resolveErrorMessage(err),
              CloudNotificationStyle.danger
            );
          }
        }
      );

      this.dismiss()
  }



  restoreVms() {
    var vmIds: number[] = [];
    this.selectedItems.map((server) => {
      vmIds.push(server.Id);
    });
    this.vmService
      .restoreVms(this.environmentName, this.subscriptionId, vmIds)
      .subscribe(
        () => {
          this.fakeServers.map((server) => {
            if (vmIds.includes(server.Id)) {
              server.instanceName = server.instanceName.split('(')[0];
            }
          });
          this.fakeServers = [...this.fakeServers];
          this.showToastNotification(
            'delete-server',
            'Restored server!',
            CloudNotificationStyle.success
          );
        },
        () => {
          this.showToastNotification(
            'delete-server',
            'Unable to restore server!',
            CloudNotificationStyle.danger
          );
        }
      );
  }

  checkForRestoration(): boolean {
    if (this.selectedItems.length == 0) {
      return false;
    }
    var isRestorable = true;
    this.selectedItems.map((server) => {
      if (
        !server.instanceName?.includes('Marked for removal') ||
        !server.instanceName
      ) {
        isRestorable = false;
      }
    });
    return isRestorable;
  }





  checkEnvironmentForRemoving(): boolean {
    if (this.environmentInfo == null) {
      return false;
    }
    if (this.environmentInfo?.removalDate == '') {
      return true;
    } else {
      return false;
    }
  }

  private getSSH(username: string, ip: string): string {
    if (!username && !ip) return '';
    return `ssh -i /path/to/your-key.pem ${username}@${ip}`;
  }



  showToastNotification(
    context: string,
    message: string,
    toastType: CloudNotificationStyle
  ) {
    this.notificationService.createorUpdateToastNotification(
      context,
      message,
      toastType
    );
  }

  getAllServersToRefresh() {
    this.isServersLoading = true;
    this.getServers();
    this.clearSelection()
  }

  private clearSelection() {
    this.selection.clear()
  }
  refresh(select: CheckBoxSelection = CheckBoxSelection.CLEAR) {
    this.allVMsClusterFormationComplete = false;
    this.vmClusterFormationStatuses.forEach(e => {
      e.isClusterFormationComplete = false;
    })
    this.triggerClusterFormationRefresh();
    this.triggerVmrefreshStatus()
    if (this.activeTab === EnvironmentTabEnum.SERVERS) {
      if (select == CheckBoxSelection.CLEAR) this.selection.clear()
      this.getServers()
    }

    if (this.activeTab === EnvironmentTabEnum.PEERINGS) {
      this.peeringSelection.clear()
      this.getPeerings()
    }

  }

  handleVmActions(action: VmAction) {
    var vmIds: number[] = [];
    this.selectedItems.map((server) => {
      vmIds.push(server.Id);
    });
    this.vmService
      .vmActions(action, vmIds, this.environmentInfo.name, this.subscriptionId)
      .subscribe();
  }

  navigateToPeeringPage() {
    // this.router.navigate([Helper.formatString(environment.routes.peering, this.subscriptionId, this.environmentName)])
    this.router.navigate(['/subscription/peering']);
  }

  navigateToDashboard() {
    this.router.navigate([environment.routes.subscription]);
  }

  navigateToAddServersPage() {
    this.selectedItems = [];
    this.router.navigate(['/addserver'], { state: { environment: this.environment } });
  }

  guide(linkType:string) {
    this.selectedItems = [];
    this.router.navigate(['/guide'], { state: { environment: this.environment , linkType:linkType,planEdition:this.planEdition} });
  }


  ngOnDestroy(): void {
    this.getServersSubscription?.unsubscribe();
    this.getVmExpiryDatesSubscription?.unsubscribe();
    this.getWebManagerPortSubscription?.unsubscribe();
    clearInterval(this.intervalId);
  }

  isAllSelected() {
    this.allSelectedVms(this.selection.selected)
    const numSelected = this.selection.selected.length;
    const numRows = this.servers.data.length
    return numSelected === numRows;
  }

  private allSelectedVms(selectedServers: any) {
    let selectedServersIds = selectedServers.map((element) => element.id)
    this.setSelectedVms(selectedServersIds)
  }

  private setSelectedVms(selectedServersIds: number[]) {
    let selectedVms: VirtualMachineDeletionRequest = {
      subscriptionId: this.subscriptionId,
      vmIds: selectedServersIds,
      environmentName: this.environment.environmentName
    }
    this.selectedServer = selectedVms
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.servers.data);
  }

  onViewServerDetails(e: MouseEvent, selectedServer: CompleteServerDetails): void {
    e.preventDefault()
    e.stopPropagation()
    this.serverToView = selectedServer;
    this.modalService.open(this.viewServerDetailsModal, { windowClass: 'viewServerDetailsModal', backdrop: 'static', keyboard: false, centered: true, size: "md" })
  }

  onConnect(e: MouseEvent, selectedServer: CompleteServerDetails): void {
    e.preventDefault();
    e.stopPropagation();
    this.serverToView = selectedServer;
    this.modalService.open(this.connectionDetailsModal, { windowClass: 'connectionDetailsModal', backdrop: 'static', keyboard: false, centered: true, size: "md" })
  }


  private observeServerStatus() {
    this.refreshService.getRefresh().pipe(takeUntil(this.unsubscribe$)).subscribe(
      (results) => {
        if ('VmStatus' in results && results.VmStatus != null && results.VmStatus.length > 0) {
          this.vmStatus = results.VmStatus
        }
      },
      (error) => {
      }
    );
  }

  intervalId = null;

  private observeServerClusterFormation() {

    this.intervalId = setInterval(()=>{
      this.triggerClusterFormationRefresh();
    }, 3000);
  }

  triggerClusterFormationRefresh() {
    this.vmClusterFormationStatuses.forEach(vm => {
      this.environmentService.isClusterFormationCompleted(this.subscriptionId, vm.vmId).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (res) => {
          vm.isClusterFormationComplete = res;
        },
        (error) => {
        }
      );
    });
  }

  public getVmTextStatus(vmId) {

    let vm = this.vmStatus.find((vm) => vm.vmId == vmId);
    if (vm == null) return 'Pending';
    else {
      let status = (' ' + vm.state).slice(1);
      return status.replace('_', ' ').toLowerCase().replace(/\b(\s\w|^\w)/g, (txt) => txt.toUpperCase());
    }
  }

  onDeleteServerInputChange():boolean{
    return this.deleteServersInput == Keys.delete
  }

  getVMStatusFromArray(vmId: number) {
    if (this.vmStatus.length > 0) {
      let vm = this.vmStatus.find((vm) => vm.vmId == vmId)
      if (vm == null) return 'pending';
      return vm?.state
    }
    return 'pending';
  }

  private parseNotificationStatus(notifications: CloudNotificationResponse[]) {
    this.servers.data.forEach((server) => {
      notifications.find((notifi) => {
        if (notifi.customArgs == server.name && notifi.toastId == "delete-vm" && notifi.status == "completed")
          this.getServers()
      })
    })
  }

  // private parseNotificationStatus(notifications:CloudNotificationResponse[]){
  //   this.environments.forEach((env)=>{
  //     notifications.find((notifi)=>{
  //       if(env.status == "provisioning" && notifi.toastId == "create-environment" && new RegExp(`\\b${env.name}\\b`).test(notifi.jobTitle) && notifi.status == "completed" ){
  //         this.getEnvironmentInformation(this.cloudSubscriptionId)
  //       }
  //     })
  //   })
  // }

  // private parseNotificationForDeletedEnv(notifications:CloudNotificationResponse[]){
  //   this.environments.forEach((env)=>{
  //     notifications.find((notifi)=>{
  //       if(env.status == "deleting" && notifi.title.includes("Deleting environment")  && new RegExp(`\\b${env.name}\\b`).test(notifi.jobTitle) && notifi.status == "completed" ){
  //         this.getEnvironmentInformation(this.cloudSubscriptionId)
  //       }
  //     })
  //   })
  // }


  private populateSelectedVmsOnDeleteModal() {
    let vmsStringList = ""
    this.selection.selected.forEach((vm) => {
      vmsStringList += "\n• "
      vmsStringList += vm.name
    })
    return vmsStringList
  }

  redirectToPeering(connection: ConnectionType): void {


    this.environmentService.checkPeeringAllowed(this.subscriptionId).subscribe({
      next:(res)=>{
        if(res) {

          this.router.navigate([environment.routes.peering_wizard], {
            queryParams: {
              subscriptionId: this.subscriptionId,
              environmentName: this.environment.environmentName,
              connection: connection,
              cloudVendor: this.environment.cloudVendor
            },
            state: {
              environment: this.environment
            }
          })

        } else {
          this.redirectToAddTenantWizard(AddTrustedTenantPathEnum.ADD_TENANT, false)
        }

      },
      error:(err:HttpErrorResponse)=>{
        this.notificationService.createToastNotification(
          'registration',
          Helper.resolveErrorMessage(err),
          CloudNotificationStyle.danger
        )
      }
    })
  }

  redirectToAddTenantWizard(path: AddTrustedTenantPath, nCacheAuthorized: boolean, tenantId?: string) {

    const url = `/subscription/${environment.routes.add_trusted_tenant}`;

    this.router.navigate([url], {
        queryParams: { subscriptionId: this.subscriptionId },
        state: { path: path, tenantId: tenantId, nCacheAuthorized: nCacheAuthorized}
    });

  };

  setActiveTab(tab: EnvironmentTabType): void {
    this.activeTab = tab
  }

  isActiveTab(tab: EnvironmentTabType): boolean {
    return tab === this.activeTab
  }

  isAllPeeringsSelected() {
    const numOfRowsSelected = this.peeringSelection.selected.length
    const totalNoOfRows = this.peerings.data.length
    return numOfRowsSelected === totalNoOfRows
  }

  canDeletePeering() {
    const numOfRowsSelected = this.peeringSelection.selected.length;
    const totalNoOfRows = this.peerings.data.length;
    return numOfRowsSelected === 1 && totalNoOfRows > 0;
  }

  toggleAllPeeringRows() {

    if (this.isAllPeeringsSelected()) {
      this.peeringSelection.clear()
      return
    }

    this.peeringSelection.select(...this.peerings.data)
  }

  onPeeringInputChange(): void {
    this.isPeeringDeletionDisabled = this.deletePeeringInput !== Keys.delete
  }

  confirmDeletePeering() {
    this.deletePeeringInput = '';
    this.selectedPeering = undefined;

    this.selectedPeering = this.peeringSelection.selected[0];
    this.selectedPeeringId = this.getResourceName(this.peeringSelection.selected[0]?.peeringId);
    this.selectedVnetConnectionId = this.peeringSelection.selected[0]?.vnetConnectionId;

    this.modalService.open(this.deletePeeringModal, { windowClass: 'deletePeeringModal', backdrop: 'static', keyboard: false, centered: true, })
  }

  deletePeering(): void {

    if (this.environment.cloudVendor.toLowerCase() === CloudVendor.AWS.toLowerCase()) {
      this.deleteAwsPeering()
    }

    if (this.environment.cloudVendor.toLowerCase() === CloudVendor.Azure.toLowerCase()) {
      this.deleteAzurePeering()
    }

  }

  deleteAwsPeering(): void {

    this.isDeletingPeering = true

    const request: RemovePeeringRequest = {
      environmentName: this.environment.environmentName,
      subscriptionId: this.subscriptionId,
      vnetConnectionId: this.selectedVnetConnectionId
    }

    this.vnetPeeringSvc.removeAwsPeering(request).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (message) => {
        this.isDeletingPeering = false
        this.dismiss()
        this.notificationService.createToastNotification('delete-aws-peeing', `Peering ${request.vnetConnectionId} is deleted successfully`, CloudNotificationStyle.success)
        this.refresh()
      },

      error: (err: HttpErrorResponse) => {
        this.isDeletingPeering = false;
        this.notificationService.createToastNotification('delete-aws-peeing', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }

    })

  }

  showClientPeeringDeleteModal(): void {

    if(this.selectedPeering?.status?.toLocaleLowerCase() === AzureVnetPeeringStatuses.CONNECTED.toLocaleLowerCase()) {
      this.modalService.open(this.clientPeeringDeleteModal, { windowClass: 'clientPeeringDeleteModal', backdrop: 'static', keyboard: false, centered: true, size: "lg"})

    } else {
      this.selectedPeering = undefined;
    };

  };

  deleteAzurePeering(): void {

    this.isDeletingPeering = true

    const request: RemovePeeringRequest = {
      environmentName: this.environment.environmentName,
      subscriptionId: this.subscriptionId,
      vnetConnectionId: this.selectedVnetConnectionId
    }

    this.vnetPeeringSvc.removeAzurePeering(request).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (peeringName) => {
        this.isDeletingPeering = false
        this.azClientPeeringConnectionName = peeringName;
        this.dismiss();
        this.showClientPeeringDeleteModal()
        this.refresh()
        this.notificationService.createToastNotification('delete-azure-peeing', `Peering is deleted successfully`, CloudNotificationStyle.success)
      },

      error: (err: HttpErrorResponse) => {
        this.isDeletingPeering = false;
        this.peeringSelection.clear();
        this.dismiss();
        this.notificationService.createToastNotification('delete-azure-peeing', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }

    })

  }

  isPAYG(): boolean {
    return StringHelper.isPAYG(this.environment.billingTerm)
  }

  isAWS(): boolean {
    return StringHelper.isAWS(this.environment.cloudVendor)
  }

  azVnetGuestUserId: string
  azVnetCustomerTenantId: string
  azVnetCustomerResourceGroupName: string
  azCustomerVnetResourceId: string
  azVnetCustomerSubscriptionId: string
  azVnetCustomerGuestEmail: string
  azVnetCustomerCidrBlock: string
  awsAccountId: string

  getAccountIDValue(row): string {
    if (StringHelper.isAzure(this.environment.cloudVendor)) {
      return `${row.azVnetCustomerGuestEmail} (${row.azVnetCustomerTenantId})`;
    }
    else return row.awsAccountId;
  }

  getAcountIDColumnName(): string {
    if (StringHelper.isAzure(this.environment.cloudVendor)) {
      return 'Guest User (Tenant ID)';
    }
    else return 'Account ID';
  }

  getResourceName(resourceName: string): string {
    return StringHelper.getLastSegment(resourceName)
  }

  dismiss(): void {
    this.modalService.dismissAll();
    this.resetAllowedIPsForm();
  }

  getReadableDate(date: string): string {
    return DateHelper.convertToReadableDate(date)
  }

  getPeeringStatus(peeringStatus: AWSVpcPeeringStatus | AzureVnetPeeringStatus): string {
    return StringHelper.formatPeeringStatus(peeringStatus)
  }

  showConfigure(status: AzureVnetPeeringStatus | AWSVpcPeeringStatus): boolean {

    if (StringHelper.isAzure(this.environment.cloudVendor)) {
      return status === AzureVnetPeeringStatuses.INIT || status === AzureVnetPeeringStatuses.INVITE_SENT || status === AzureVnetPeeringStatuses.ROLE_ASSIGNED || status === AzureVnetPeeringStatuses.INITIATED;
    }

    if (StringHelper.isAWS(this.environment.cloudVendor)) {
      return status === AWSVpcPeeringStatuses.PENDING || status === AWSVpcPeeringStatuses.AWAITING_ROUTE_ENTRY || status === AWSVpcPeeringStatuses.AWAITING_UPDATE_RULES || status === AWSVpcPeeringStatuses.PENDING_ACCEPTANCE
    }

  }

  navigateToConnectionWizard(connection: VnetPeeringResponse): void {

    if (StringHelper.isPeering(connection.type)) {

      this.router.navigate([environment.routes.peering_wizard],
        {
          queryParams: {
            subscriptionId: this.subscriptionId,
            environmentName: this.environment.environmentName,
            connection: ConnectionTypeEnum.PEERING,
            cloudVendor: this.environment.cloudVendor
          },

          state: {
            connection: connection,
            environment: this.environment
          }
        }
      )

    }

  }

  getColumnNames(): string[] {
    const baseColumns = ['Server Name', 'IP Address', 'Created At', 'Status', 'Action'];
    const updatedColumns = this.isPublicIpEnabled() ? [...baseColumns.slice(0, 2), 'Public IP Address', ...baseColumns.slice(2)] : baseColumns;
    return updatedColumns
  }

  isPublicIpEnabled(): boolean {
    return Boolean(this.environment?.assignPublicIp);
  };

  initializeallowedIPsForm(): void {

    this.allowedIPsFormGroup = this.formBuilder.group({
      allowedIPs:['', [Validators.required, FormValidators.noWhitespaceValidator()]]
    });

  };

  get allowedIPsForm() {
    return this.allowedIPsFormGroup?.controls;
  };

  getAllowedIPsList(subscriptionId: string, environmentName: string): void {

    this.isLoadingAllowedIPs = true;

    this.environmentService.getAllowedIPs(subscriptionId, environmentName).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (response) => {

        if (response.length == 1 && response[0] == '0.0.0.0/0') {
          this.selectivePublicIps = false;
        }
        else {
          this.selectivePublicIps = true;
          this.isLoadingAllowedIPs = false
          this.allowedIPsForm.allowedIPs.setValue(response.join(', '));
          this.allowedIPs = response;
          this.duplicateAllowedIPs = response;
        }
      },

      error: (err: HttpErrorResponse) => {
        this.isLoadingAllowedIPs = false;
        this.showToastNotification("get-allowed-ips", Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }

    });

  };

  isClusterFormationComplete(vmId): boolean {

    if (!this.allVMsClusterFormationComplete) {
      let allCompleted = false;
      this.vmClusterFormationStatuses.forEach(vm => {
        if (vm.isClusterFormationComplete) allCompleted = true;
        else allCompleted = false;
      });

      if (allCompleted) {
        this.allVMsClusterFormationComplete = true;
        clearInterval(this.intervalId);
      }
    }

    let found = this.vmClusterFormationStatuses.find(e => e.isClusterFormationComplete === false);
    if (found) return false;
    else return true;

    // let anyFormingCluster = false;
    // this.vmClusterFormationStatuses.find(e => {
    //   if (e.isClusterFormationComplete == false)
    // })

    // let vm = this.vmClusterFormationStatuses.find((vm) => vm.vmId == vmId);
    // if (vm == null) return false;
    // else return vm.isClusterFormationComplete;
  }

  private resetAllowedIPsForm(): void {
    this.allowedIPsFormGroup.reset();
    this.isAllowedIPsSubmitted = false;
    this.invalidIPsErr = [];
  }

  openConfigureIPsModal(): void {
    this.isAddingAllowedIPs = false;
    this.resetAllowedIPsForm();
    this.getAllowedIPsList(this.subscriptionId, this.environment.environmentName);
    this.modalService.open(this.configureAllowedIPsModal, { windowClass: 'configureAllowedIPsModal', backdrop: 'static', keyboard: false, centered: true, size: "lg" })
  };

  openDeleteServerModal(){
    if (this.checkIfAllVmsSelected()) {
      this.notificationService.createToastNotification("Environment Deatils", "Every environment requires at least one server to function correctly. If you want to remove all servers, consider deleting the environment instead.", CloudNotificationStyle.danger)
      return;
    }

    this.modalService.open(this.deleteServersModal, { windowClass: 'deleteServersModal', backdrop: 'static', keyboard: false, centered: true})
  }

  onSaveAllowedIPs(): void {

    this.isAllowedIPsSubmitted = true;

    if(this.allowedIPsFormGroup.valid) {

      const validation = IPValidator.validateAllowedIPs(this.allowedIPsForm.allowedIPs.value);

      if (!validation.valid) {
        this.invalidIPsErr = validation.errors;
        this.allowedIPsForm.allowedIPs.setErrors({ invalidIPs: true });

      } else {
        this.invalidIPsErr = [];
        this.allowedIPsForm.allowedIPs.setErrors(null);
        this.updateIPsList(validation.validIPs);
      };


    };

  };

  updateIPsList(newIPs: string[]): void {
    const uniqueIPs = new Set([...newIPs]);
    this.duplicateAllowedIPs = Array.from(uniqueIPs);
  };

  addAllowedIPs(): void {

    if (this.selectivePublicIps)
    {
      this.onSaveAllowedIPs();

      if(this.allowedIPsFormGroup.invalid || this.duplicateAllowedIPs.length === 0) {
        return;
      }

    }
    else {
      this.duplicateAllowedIPs = ['0.0.0.0/0'];
    }

    this.isAddingAllowedIPs = true;

    const request: AllowedIPRequest = {
      allowedIPsList: this.duplicateAllowedIPs,
      environmentName: this.environment.environmentName,
      nCacheSubscriptionId: this.subscriptionId
    };

    this.environmentService.addAllowedIPs(request).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (response) => {
        this.isAddingAllowedIPs = false;
        this.dismiss();
        this.getAllowedIPsList(this.subscriptionId, this.environment.environmentName);
        this.notificationService.createToastNotification("add-allowed-ips", response, CloudNotificationStyle.success)
      },

      error: (err: HttpErrorResponse) => {
        this.isAddingAllowedIPs = false;
        this.getAllowedIPsList(this.subscriptionId, this.environment.environmentName);
        this.notificationService.createToastNotification("add-allowed-ips", Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }

    });

  };

  private getExternalLinks(): void {

    this.environmentService.getExternalLinks().pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (links) => {
        this.azLinkDeletePeering = links.az_link_delete_peering ?? undefined;
        this.ncacheConnectCachePublicIPLink = links.ncache_connect_cache_public_ip_link ?? undefined;
        this.nCacheWebManagerLinkTemplate = links.link_management_center_template ?? undefined
      },

      error: (err: HttpErrorResponse) => {
        this.notificationService.createToastNotification('get-external-links', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger)
      }

    });

  };

  openOrFocusWindow(publicIp: string): void {
    const url = this.nCacheWebManagerLink(publicIp);

    if (!this.openedWindows[publicIp] || this.openedWindows[publicIp]?.closed) {
      this.openedWindows[publicIp] = window.open(url, `manageWindow-${publicIp}`);
    } else {
      this.openedWindows[publicIp]?.focus();
    }
  }


  nCacheWebManagerLink(publicIp : string):string{
    if(this.nCacheWebManagerLinkTemplate != undefined && publicIp != null)   return StringHelper.replacePublicIpHelper(publicIp, this.nCacheWebManagerLinkTemplate)
  }

}
